import { apiWrapper } from "@/services/api";

export const usedBook = async (id) => {
  try {
    const apiParams = JSON.stringify(true);
    await apiWrapper("PUT", `books/${id}/is_used`, apiParams);
  } catch (err) {
    console.log("ERROR!! usedBook()");
    throw err;
  }
};
